
const navList = [
    // {
    //     _id: 0,
    //     name: 'Subscription',
    //     url: '/subscription',
    //     icon: 'bi bi-bookmark-check',
    // },
      {
        _id: 1,
        name: 'Reviews and Ratings',
        url: '/lab-reviews',
        icon: 'bi bi-bookmark-check',
    },
];

export default navList;
